import React from 'react';
import HelpBubble from 'js/components/help_bubble';

function WrapUpAnalyticsCard(props) {
    const {icon, data, subtitle, renderForPdf, helpText} = props;

    const toolTip =
        !renderForPdf && helpText ? (
            <HelpBubble text={helpText} inline multiline place="bottom" />
        ) : null;

    return (
        <div className="wrap-up-analytics-card">
            <div className="wrap-up-info">
                <img src={icon} className="wrap-up-analytics-icon" />
                <div className="wrap-up-data-section">
                    <div className="wrap-up-data">{data}</div>
                    <div className="wrap-up-subtitle">
                        {subtitle}
                        {toolTip}
                    </div>
                </div>
            </div>

            {/*STYLES*/}

            <style>{`
        .wrap-up-analytics-card {
        background-color: #f6f4f4;
        box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.2);
        border-radius: 10px;
        width: 30%;
        height: 150px;
        margin: 10px;
        }

        .wrap-up-info {
        width: 90%;
        }

        .wrap-up-analytics-icon {
        position: relative;
        bottom: 4px;
        padding-left: 20px;
        }

        .wrap-up-data-section {
        height: 50%;
        text-align: center;
        padding: 0px 20px;
        margin-bottom: 12px;
        }

        .wrap-up-data {
        font-size: 36px;
        font-weight: bold;
        color: #00A1E1;
        }

        .wrap-up-subtitle {
        width: 110%;
        text-align: center;
        font-size: 12px;
        }
        `}</style>

            {/*STYLE FOR WEB*/}
            {!renderForPdf ? (
                <style>{`
        .wrap-up-analytics-card {
        display: flex;
        justify-content: center;
        }

        .wrap-up-info {
        display: flex;
        align-items: center;
        justify-content: center;
        }
        `}</style>
            ) : null}

            {/*STYLE FOR PDF*/}
            {renderForPdf ? (
                <style>{`
        .wrap-up-analytics-card {
        display: inline-block;
        vertical-align: top;
        }

        .wrap-up-info {
        margin: auto;
        height: 100%;
        }

        .wrap-up-info img {
        width: 40px;
        display: inline-block;
        position: relative;
        vertical-align: middle;
        top: 20%;
        padding-left: 10px;
        }

        .wrap-up-data-section {
        width: 50%;
        height: 50%;
        display: inline-block;
        vertical-align: middle;
        position: relative;
        top: 25%;
        padding: 0 10px;
        }

        .wrap-up-data {
        font-size: 30px;
        }

        .wrap-up-subtitle {
        width: 100%;
        font-size: 11px;
        }
        `}</style>
            ) : null}
        </div>
    );
}

WrapUpAnalyticsCard.propTypes = {};

export default WrapUpAnalyticsCard;



// WEBPACK FOOTER //
// ./campaign_analytics/campaign_wrap_up/campaign_wrap_up_analytics/wrap_up_analytics_card.js